import { Button, styled, Typography } from '@mui/material'
import { capitalize } from 'lodash'
import { getLoginProviderConfig } from '../../../config/firebase'

export const IdpContainer = styled('div')({
  fontFamily: '"Outfit", Arial, sans-serif',
  display: 'flex',
  flexDirection: 'column',
  flex: 0,
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center'
})

const IdpButton = styled(Button)(({ theme }) => ({
  marginTop: 0,
  marginBottom: '10px',
  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
  alignItems: 'center',
  color: theme.palette.customGrey[700],
  border: '1px solid #D0D5DD',
  borderRadius: '8px',
  flexShrink: '0',
  flexGrow: '0',
  textTransform: 'none'
}))

interface SSOButtonProps {
  action: string
  disabled: boolean
  providerId: string
  handleProvider: () => Promise<void>
}

export default function SSOButton({ action, disabled, providerId, handleProvider }: SSOButtonProps) {
  const providerConfig = getLoginProviderConfig(providerId)

  const { LogoSvg, name } = providerConfig

  return (
    <IdpButton disabled={disabled} fullWidth sx={{ padding: 0, textAlign: 'center', display: 'block' }} onClick={handleProvider}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
        <LogoSvg width={32} height={32} />
        <Typography sx={{ ml: '6px', fontWeight: 500 }}>{`${action} ${capitalize(name)}`}</Typography>
      </div>
    </IdpButton>
  )
}
